import Service from "./config/ConfigRepositoryAuth";

export default {
  async getByDate(date) {
    return await Service.get(`audit-logs/${date}`);
  },

  async getByDocument(id) {
    return await Service.get(`audit-logs/document/${id}`);
  },
};
